import { Component, Input, OnInit } from '@angular/core';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { TranslateService } from '@ngx-translate/core';
import { BaseManagement } from 'src/app/core/services/base-management';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { InspectionService } from 'src/app/pages/transaction-admin/services/inspection.service';

@Component({
	selector: 'pdf-inspection-viewer',
	templateUrl: './pdf-inspection-viewer.component.html',
	styleUrls: ['./pdf-inspection-viewer.component.scss']
})
export class PdfInspectionViewerComponent extends BaseManagement implements OnInit {
	@Input() isVisibleButtons = true;
	@Input() validateForm = false;
	requirement: any;
	serverError: any = '';
	pdfSrc: any;
	requirementItem: any;
	itemToEdit: any = { Id: null };
	minimize = false;
	subscriptions: Subscription[] = [];
	revisionStatusLog: any = {};
	public downloaded: string | undefined;
	isFormValid = false;

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public mainService: InspectionService,
		public ngxService: NgxExtendedPdfViewerService,
		public translate: TranslateService
	) {
		super();
	}

	ngOnInit() {
	}

	ngOnDestroy() {
		this.subscriptions.forEach(s => s.unsubscribe());
	}


	close() {
		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.closeWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.closeWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.mainService.fileToLoad = null;
					}
				});
			});
	}

	tryDownloadAsBlob(action) {
		if (!this.isFormValid) {
			this.alertCompleteForm();
			return;
		}

		if (this.isSaving()) return;

		this.translate
			.get([
				'message.deleteConfirmText',
				'message.yes',
				'message.no',
				'message.requirement',
				'message.deleted',
				'message.unableRequirement',
				'message.done',
				'pdfform.saveWarn',
			])
			.subscribe((translations) => {
				const dialogRef = this.dialog.open(DialogYesNoComponent, {
					width: '250px',
					data: {
						msg: translations['pdfform.saveWarn'],
						yesText: translations['message.yes'],
						noText: translations['message.no'],
					},
				});

				dialogRef.afterClosed().subscribe((result) => {
					if (result === 1) {
						this.startSaving(action);
						//this.downloadAsBlob(action);
					}
				});
			});
	}

	// public async downloadAsBlob(action): Promise<void> {

	// 	const blob = await this.ngxService.getCurrentDocumentAsBlob();
	// 	if (blob) {
	// 		this.downloaded = 'The BLOB contains ' + blob.size + ' byte.';

	// 		var formData = new FormData();
	// 		var files: File[] = [];
	// 		var filePdf = new File([blob], "name.pdf");
	// 		files.push(filePdf);

	// 		Array.from(files).forEach((f) => formData.append('file', f));

	// 		formData.append('id', this.mainService.UserProcessRequirementId);
	// 		formData.append('processId', this.mainService.ProcessId);

	// 		this.mainService
	// 			.uploadRequirementFile(formData)
	// 			.then((updatedRequirement) => {
	// 				if (this.revisionStatusLog.CompletedDate == null) {
	// 					let params: any = {};
	// 					params.userProcessId = this.requirementItem.ProcessId;
	// 					params.requirementId = this.requirementItem.RequirementId;

	// 					this.transactionRevisionExternalService.remediateRevisionStatusLog(params)
	// 						.then((data: any) => {
	// 							console.log(data);
	// 						})
	// 						.catch((err) => {
	// 							console.log('error', err);
	// 							this.serverError = "An error ocurred when adding the revision status log."

	// 						});
	// 				}

	// 				this.mainService.pdfCommunicator.next("stop-saving");

	// 				this.requirement = updatedRequirement;

	// 				this.mainService.updateItemByField(
	// 					this.requirement.UserProcessRequirementId,
	// 					'UserProcessRequirementId',
	// 					this.requirement
	// 				);

	// 				this.transactionService
	// 					.getTimeline(this.requirement.ProcessId)
	// 					.then(() => {

	// 						this.transactionService.getTransactionsForUser()
	// 							.then(() => {

	// 								this.mainService.fileToLoad = null;
	// 							});

	// 					});
	// 			})
	// 			.catch((err) => {
	// 				console.log('error', err);
	// 				this.translate
	// 					.get(['error.documentUplaod'])
	// 					.subscribe((translations) => {
	// 						this.stopSaving();

	// 						this.serverError = "Hubo un problema al intentar enviar el documento"
	// 					});
	// 			});

	// 	} else {
	// 		this.downloaded = 'download failed';
	// 		this.stopSaving();
	// 	}
	// }

	async onFormChange(event: any) {
		if (this.validateForm) {
			await this.ngxService.getFormData().then((formData: any) => {
				const missingFields: string[] = [];

				for (const field of formData) {
					if (field.fieldAnnotation.required && !field.fieldAnnotation.value) {
						missingFields.push(field.name);
					}
				}

				this.isFormValid = missingFields.length === 0;
			});
		} else {
			this.isFormValid = true;
		}
	}

	alertCompleteForm() {
		alert('Rellene todos los campos obligatorios.');
	}
}
